// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Home_container__lfmbs {
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background: linear-gradient(
    90deg,
    rgba(255, 215, 215, 1) 0%,
    rgba(201, 182, 255, 0.9500175070028011) 100%
  );
}
.Home_titleContainer__RizBu {
  display: flex;
  align-items: center;
  justify-content: center;
  column-gap: 150px;
  padding-block-end: 40px;
  font-size: 17px;
  font-weight: 500;
}
.Home_systemsContainer__3VMMo {
  display: flex;
  align-items: center;
  justify-content: center;
  column-gap: 50px;
  flex-wrap: wrap;
  row-gap: 40px;
}
.Home_system__KKmEF {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 170px;
  height: 90px;
  border: 6px bisque double;
  font-size: 14px;
  font-weight: 600;
  border-radius: 4px;
  transition: all 0.35s ease-out;
  color: rgb(43, 37, 82);
}
.Home_system__KKmEF:hover {
  transform: translateY(-6px) scale(1.005);
  box-shadow: 0px 7px 15px 0px rgba(0, 0, 0, 0.3);
  cursor: pointer;
}
@media all and (max-width: 600px) {
  .Home_titleContainer__RizBu {
    column-gap: 50px;
  }
  .Home_systemsContainer__3VMMo {
    column-gap: 20px;
    row-gap: 10px;
  }
}
@media all and (max-width: 500px) {
  .Home_titleContainer__RizBu {
    column-gap: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/DefaultPages/Home/Home.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB;;;;GAIC;AACH;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,8BAA8B;EAC9B,sBAAsB;AACxB;AACA;EACE,wCAAwC;EAGxC,+CAA+C;EAC/C,eAAe;AACjB;AACA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,aAAa;EACf;AACF;AACA;EACE;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".container {\r\n  width: 100%;\r\n  height: 100vh;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-direction: column;\r\n  background: linear-gradient(\r\n    90deg,\r\n    rgba(255, 215, 215, 1) 0%,\r\n    rgba(201, 182, 255, 0.9500175070028011) 100%\r\n  );\r\n}\r\n.titleContainer {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  column-gap: 150px;\r\n  padding-block-end: 40px;\r\n  font-size: 17px;\r\n  font-weight: 500;\r\n}\r\n.systemsContainer {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  column-gap: 50px;\r\n  flex-wrap: wrap;\r\n  row-gap: 40px;\r\n}\r\n.system {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 170px;\r\n  height: 90px;\r\n  border: 6px bisque double;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  border-radius: 4px;\r\n  transition: all 0.35s ease-out;\r\n  color: rgb(43, 37, 82);\r\n}\r\n.system:hover {\r\n  transform: translateY(-6px) scale(1.005);\r\n  -webkit-box-shadow: 0px 7px 15px 0px rgba(0, 0, 0, 0.3);\r\n  -moz-box-shadow: 0px 7px 15px 0px rgba(0, 0, 0, 0.3);\r\n  box-shadow: 0px 7px 15px 0px rgba(0, 0, 0, 0.3);\r\n  cursor: pointer;\r\n}\r\n@media all and (max-width: 600px) {\r\n  .titleContainer {\r\n    column-gap: 50px;\r\n  }\r\n  .systemsContainer {\r\n    column-gap: 20px;\r\n    row-gap: 10px;\r\n  }\r\n}\r\n@media all and (max-width: 500px) {\r\n  .titleContainer {\r\n    column-gap: 20px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Home_container__lfmbs`,
	"titleContainer": `Home_titleContainer__RizBu`,
	"systemsContainer": `Home_systemsContainer__3VMMo`,
	"system": `Home_system__KKmEF`
};
export default ___CSS_LOADER_EXPORT___;
